//@flow

import {stringRefcount} from './refcount'
export const nextBarrierID = stringRefcount()
